<template>
  <header class="header">
    <div>
      <router-link class="logo" to="/">
      <h1>Cling</h1>
      </router-link>
    </div>
  </header>
</template>

<script>
  export default {
    name: 'header'
  }

</script>
